// extracted by mini-css-extract-plugin
export var checked = "ChooseMany_checked__smJMD";
export var chooseManyContainer = "ChooseMany_chooseManyContainer__Bcr8J";
export var md = "768px";
export var shared = "'../../../shared.module.css'";